<!-- 新增派单规则 -->
<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{$t('common.New')}} {{$t('send.OrderingRule')}}
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">{{$t('common.save')}}</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b @click="showRepeatDialog = true"> {{$t('common.MainMessage')}}</b>
            </div>

            <div class="iname">
              <em class="f-red">*</em>
              <span> {{$t('common.ServiceNetwork')}}:</span>
              <el-input style="width: 165px;" type="text" autocomplete="off" clearable v-model="formData.siteName"
                :readonly="true">
                <i slot="suffix" style="margin-top: 0" class="el-input__icon el-icon-search"
                  @click="showPreconditionDialog = true"></i>
              </el-input>
              <!-- <div class="iname">
                <em class="f-red">*</em>
                <span>有效时间:</span>
                <el-date-picker v-model="formData.date" type="daterange" range-separator="-" start-placeholder="开始日期"
                  value-format="yyyy-MM-dd" style="width:20vw" end-placeholder="结束日期">
                </el-date-picker>
              </div> -->
              <div class="iname">
                <em class="f-red">*</em>
                <span> {{$t('common.StartTime')}}:</span>
                <el-date-picker v-model="formData.beginDate" value-format="yyyy-MM-dd" type="date" >
                </el-date-picker>
              </div>
              <div class="iname">
                <em class="f-red">*</em>
                <span> {{$t('common.EndTime')}}:</span>
                <el-date-picker v-model="formData.endDate" type="date" default-time="2090-12-30" >
                </el-date-picker>
              </div>
            </div>


            <div class="brand">
              <div>
                <span> {{$t('common.ServiceBrand')}}：</span>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                  {{$t('common.All')}}
                </el-checkbox>
              </div>
              <div class="brand_item2">
                <el-checkbox-group v-model="checkedBrand" @change="handleCheckedBrandChange">
                  <el-checkbox v-for="brand in brandList" :label="brand.id" :key="brand.id">{{
                    brand.brandName
                  }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>


          </div>

          <div style="display: flex;">
            <div class="d-item" style="margin-right: 10px">
              <div class="title first">
                <b> {{$t('common.ProductType')}}</b>
              </div>
              <div>

                <vxe-table :stripe="true" ref="itemTable"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :checkbox-config="{}"
                  :row-style="{ fontSize: '12px', }" show-overflow height="300" :column-config="{ resizable: true }"
                  resizable :tree-config="{ transform: true, }" :data="tableData1" @checkbox-change="selectItems"
                  @checkbox-all="selectItems">
                  <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                  <vxe-column field="categoryName" width="150"  :title="$t('common.ProductType')"></vxe-column>
                </vxe-table>

              </div>
            </div>
            <!-- 服务类型 -->
            <div class="d-item" style="margin-right: 10px">
              <div class="title first">
                <b> {{$t('common.ServiceType')}}</b>
              </div>
              <div>

                <vxe-table :stripe="true" ref="serviceTypeTable"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  show-overflow height="300" :column-config="{ resizable: true }" :checkbox-config="{}" resizable
                  :tree-config="{
                    transform: true,
                  }" :data="serviceTypeData" @checkbox-change="selectServiceType" @checkbox-all="selectServiceType">
                  <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                  <vxe-column field="serviceTypeName" width="150"  :title="$t('common.ServiceType')"></vxe-column>
                </vxe-table>

              </div>
            </div>
            <div class="d-item" style="margin-right: 10px">
              <div class="title first">
                <b> {{$t('common.PurchaseChannel')}}</b>
              </div>
              <div>
                <vxe-table :stripe="true" ref="buyChannelTable" row-id="id"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  :checkbox-config="{}" show-overflow height="300" :column-config="{ resizable: true }" resizable
                  :data="buyDatas" @checkbox-change="buyChannelCheckChange" @checkbox-all="buyChannelCheckChange">
                  <vxe-column type="checkbox" width="80"></vxe-column>
                  <vxe-column field="buyChannelName" width="150"  :title="$t('common.PurchaseChannel')"></vxe-column>
                </vxe-table>

              </div>
            </div>
            <div class="d-item">
              <div class="title first">
                <b>{{$t('common.ServiceArea')}}</b>
              </div>
              <div class="iname2" style="display: flex;">
                <div class="item1">
                  <em class="f-red">*</em>
                  <span style="white-space:nowrap">{{$t('common.ServiceArea')}}:</span>
                </div>
                <el-form-item>
                  <template>
                    <!-- <el-cascader :props="areaProps" v-model="tenant.userProvince" :clearable="true" style="width: 9vw;"
                      @change="handleChange"  collapse-tags  ref="cascaderAddr">
                    </el-cascader> -->
                    <el-input style="width: 9vw;margin-top: 5px;" v-model="tenant.userProvince" @focus="showItemPop = true"
                      > </el-input>
                  </template>
                </el-form-item>
                <!-- <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData">
                  <i class="el-icon-plus"></i>
                  添加服务区域
                </el-button> -->
                <el-button style="margin: 5px;" type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                  <i class="el-icon-delete"></i>
                  {{$t('common.BatchDeletion')}}
                </el-button>
              </div>
              <div class="tab">
                <vxe-table ref="filterTable" :data="areaData" class="table_item pic_item" :stripe="true"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  show-overflow height="260" :column-config="{ resizable: true }" @checkbox-all="areaSelectAll"
                  @checkbox-change="areaSelect">
                  <vxe-column type="checkbox" width="40"></vxe-column>
                  <vxe-column field="areaNamePath"  :title="$t('common.ProvincialAddress')" width="330">
                  </vxe-column>

                  <vxe-column  :title="$t('common.Controls')" width="90">
                    <template slot-scope="scope">
                      <div @click="handleDelete(scope.row.id)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                          popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
            </div>
          </div>


          <div style="height:10px"></div>
        </div>

      </div>


    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commit="commitSelectedRow" :visiable.sync="showPreconditionDialog"
      :isWithoutEnd="1" multi="true" />
    <!-- 重复单 -->
    <repeatDialog v-if="showRepeatDialog" @commitSave="commitSave" :visiable.sync="showRepeatDialog" :param="formData" />
    <!-- 地区选择 -->
    <addressDialog :visiable.sync="showItemPop" v-if="showItemPop" @addressList="addressList" />
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import request from "@/router/axios";
import repeatDialog from './dialog.vue';
// 地区选择
import addressDialog from '@/views/dialogCommon/addressDialog.vue';


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    addressDialog,
    Tinymce,
    preconditionDialog,
    // 重复单
    repeatDialog
  },

  data() {
    return {
      showItemPop: false,

      saveDataUrl: '/basic/snAutoDispatchClean/add',
      getDispatchByTimeUrl: '/basic/snAutoDispatchClean/getIsExists',
      getAreaDataUrl: '/basic/basArea/getList',
      getBrandDataUrl: '/basic/snCompanyBrand/getBrandList',
      addressUrl: '/basic/basArea/getListByIdList',
      getAreaPathDataUrl: '/basic/basArea/getAreaPathList',
      getServerTypeDataUrl: '/basic/basServiceType/getAllTree',
      getItemCategoryDataUrl: '/basic/basItemCategory/getAllTree',
      buychannelUrl: "/basic/basBuyChannel/getList",
      serviceTypeData: [],
      buyDatas: [],
      showPreconditionDialog: false,
      showRepeatDialog: false,

      areaProps: {
        multiple: true,
        lazy: true,
        emitPath: false,
        // checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },

      checkAll: false,
      isIndeterminate: false,
      activeName: 'first',

      // 基本信息
      tenant: {
        status: 0,
        tenantAttachmentDTOs: []
      },
      showProductCategoryDialog: false,

      area: {
        temp: {},
        checkedArray: []
      },

      serviceType: [],
      itemCategory: [],
      tableData1: [],
      areaData: [],
      brandList: [],
      checkedBrand: [],
      formData: {
        // data: [new Date(), new Date(2090, 10, 11,)],
        beginDate:'',
        endDate:'2090-12-30',

        brandId: [],
        serviceTypeIds: [],
        buyChannelIds: [],
        itemCategoryIds: [],
        areaId: []
      },
    };
  },

  computed: {},

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId
  },

  mounted() {
    this.loadBrandOption()
    this.loadServerTypeTableData()
    this.loadItemCategoryTableData()
    this.loadBuyDatas()
  },

  methods: {
    addressList(data) {
      console.log(data, "穿过i来");

      this.$http({
        url: this.addressUrl,
        method: 'post',
        data: {
          idList: data
        }
      }).then(res => {
        console.log(res, "选择的地区");
        let tempArray = this.areaData
        res.data.data.forEach(item => {
          tempArray.push({
            id: item.id,
            areaNamePath: item.areaNamePath
          })
        })
        this.areaData = this.uniqueArr(tempArray)
        // if(res!==''){
        //   this.areaData.push(res.data.data)
        // }

      })
    },
    commitSelectedRow(data) {
      // this.siteObj.id = data.id
      // this.siteObj.name = data.name
      this.formData.siteId = data.id;
      this.formData.siteName = data.name;
      // this.siteObj.name = data
    },


    /***************************              品牌                 **************************/
    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: this.getBrandDataUrl,
        method: 'post',
        data: {
          usable: 1
        }
      }).then(res => {
        this.brandList = res.data.data
      })
    },

    // 品牌单选
    handleCheckAllChange(val) {
      this.checkedBrand = val ? this.brandList.map(item => item.id) : []
      this.isIndeterminate = false
      this.formData.brandId = [];
      if (val) {
        this.formData.brandId.push(0);
        this.formData.isAllBrandId = 1
      }
    },

    // 品牌全选
    handleCheckedBrandChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandList.length;
      if (this.checkAll) {
        this.formData.brandId = [];
        this.formData.brandId.push("0");
        this.formData.isAllBrandId = 1
      } else {
        this.formData.isAllBrandId = 0
        const brandIds = [];
        for (let i = 0; i < checkedCount; i++) {
          brandIds.push(value[i])
        }
        this.checkedBrand = brandIds;
        this.formData.brandId = brandIds;
      }
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.brandList.length;
    },
    /***************************              品牌                 **************************/


    /***************************              服务类型                 **************************/
    // 一级服务类型加载
    loadServerTypeTableData() {
      this.$http({
        url: this.getServerTypeDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.serviceTypeData = res.data.data
      })
    },
    // 服务勾选
    selectServiceType() {
      this.formData.serviceTypeIds = [];
      if (this.$refs.serviceTypeTable.isAllCheckboxChecked()) {
        this.formData.serviceTypeIds.push(0);
        this.formData.isAllServerTypes = 1;
      } else {
        this.formData.isAllServerTypes = 0;
        const tableData = this.$refs.serviceTypeTable.getCheckboxRecords();
        const serveTypeId = [];
        for (let i = 0; i < tableData.length; i++) {
          //存在下级节点
          serveTypeId.push(tableData[i].id)
          // //判断list是否存在父节点id
          // if(tableData[i].parentId){
          //   if(serveTypeId.indexOf(tableData[i].parentId)==-1){
          //     serveTypeId.push(tableData[i].parentId);
          //   }
          // }
        }
        this.formData.serviceTypeIds = serveTypeId;
      }
    },
    /***************************              服务类型                 **************************/

    loadBuyDatas() {
      this.$http({
        url: this.buychannelUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.buyDatas = res.data.data
      })
    },
    buyChannelCheckChange() {
      if (this.$refs.buyChannelTable.isAllCheckboxChecked()) {
        this.formData.buyChannelIds.push(0);
        this.formData.isAllBuyChannel = 1;
      } else {
        this.formData.isAllBuyChannel = 0;
        const tableData = this.$refs.buyChannelTable.getCheckboxRecords();
        var buyChannelId = [];
        for (let i = 0; i < tableData.length; i++) {
          buyChannelId.push(tableData[i].id)
        }
        this.formData.buyChannelIds = buyChannelId;
      }
    },



    /***************************               产品分类                 **************************/
    // 一级产品分类加载
    loadItemCategoryTableData() {
      this.$http({
        url: this.getItemCategoryDataUrl,
        method: 'post',
        data: {
          categoryType: 1,
          usable: 1
        }
      }).then(res => {
        this.tableData1 = res.data.data
      })
    },


    // 产品勾选
    selectItems({ records }) {

      if (this.$refs.itemTable.isAllCheckboxChecked()) {
        this.formData.itemCategoryIds.push(0);
        this.formData.isAllItemCategory = 1;
      } else {
        this.formData.isAllItemCategory = 0;
        const tableData = this.$refs.itemTable.getCheckboxRecords();
        const itemId = [];
        for (let i = 0; i < tableData.length; i++) {
          //存在下级节点
          itemId.push(tableData[i].id)
          // //判断list是否存在父节点id
          // if(tableData[i].parentId){
          //   if(itemId.indexOf(tableData[i].parentId)==-1){
          //     itemId.push(tableData[i].parentId);
          //   }
          // }
        }
        this.formData.itemCategoryIds = itemId;
      }
    },

    /***************************               产品分类                 **************************/


    /***************************               服务地区                 **************************/
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: this.getAreaDataUrl,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleChange() {
      let areaNodes = this.$refs["cascaderAddr"].getCheckedNodes();
      console.log(areaNodes, "areaNodes全部选中的值");

      let areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      areaNode = areaNode.filter(option => !(option.parent && option.parent.checked))

      console.log(areaNode, "areaNode11111");

      let CheckedNodes = this.$refs["cascaderAddr"].getCheckedNodes();
      // // console.log(CheckedNodes, '11111111')
      CheckedNodes = CheckedNodes.filter(option => (option.parent && option.parent.checked))
      console.log(CheckedNodes, "CheckedNodes2222的值");



      this.area.temp = {
        id: areaNode[0].value,
        level: areaNode[0].level
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },

    // 添加地区列表
    addAreaData() {
      if (this.area.temp.level < 3) {
        this.$message.warning('请至少选择到市级地址')
      } else {
        if (this.area.temp.level === 4 || this.area.temp.level === 3) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    // 单个地区删除
    handleDelete(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.areaData = this.areaData.filter(item => item.id !== id)
      })
    },

    // 批量删除地区
    handleDeleteList() {
      console.log(this.area.checkedArray)
      if (this.area.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.area.checkedArray.forEach(item => {
            this.areaData = this.areaData.filter(item1 => item1.id !== item.id)
          })
          this.area.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.area.checkedArray.push(data.row)
      } else {
        this.area.checkedArray = this.area.checkedArray.filter(item => item.id !== data.row.id)
      }
    },

    // 地址全选
    areaSelectAll(selection) {
      this.area.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area.checkedArray.push(item)
      })
    },

    /***************************               服务地区                 **************************/




    saveData() {
      let areaIdList = this.areaData.map(item => item.id)
      this.formData.areaId = areaIdList;
      if (this.formData.siteId === '') {
        this.$message.error('请选择网点')
        return
      }
      if (this.formData.serviceTypeIds.length === 0) {
        this.$message.error('请选择服务类型')
        return
      }
      if (areaIdList.length === 0) {
        this.$message.error('请选择服务地区')
        return
      }
      if (this.formData.brandId.length === 0) {
        this.$message.error('请选择品牌')
        return
      }
      if (this.formData.itemCategoryIds.length === 0) {
        this.$message.error('请选择产品类型')
        return
      }
      if (this.formData.beginDate === '') {
        this.$message.error('请选择开始日期')
        return
      }   if (this.formData.endDate === '') {
        this.$message.error('请选择结束日期')
        return
      }
      // let date = this.formData.date;
      // if (date != null && date.length > 0) {
      //   this.formData.beginDate = date[0]
      //   this.formData.endDate = date[1]
      // }else{
      //   this.$message.error('请输入对应的有效时间！')
      //   return
      // }
      this.$baseConfirm('您确定要保存吗？').then(() => {

        this.$mask.open()
        //判断当前时间段中是否存在派单规则
        this.$http({
          url: this.getDispatchByTimeUrl,
          method: `post`,
          data: this.formData
        }).then((res) => {
          if (res.data.type == 'success' && res.data.data.length > 0) {
            this.$mask.close()
            this.showRepeatDialog = true
          } else {

            this.doSave()
          }

        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！");
          this.$mask.close()

        })

      })

    },
    commitSave(type) {
      this.showRepeatDialog = type
      this.$mask.open()
      this.doSave()
    },

    doSave() {
      this.$http({
        url: this.saveDataUrl,
        method: `post`,
        data: this.formData
      }).then(() => {
        this.$emit('editViewDataUpdate')
        this.$message.success("保存成功！");
        this.$mask.close()

      }).catch(e => {
        console.error(e)
        this.$message.error("保存失败！");
        this.$mask.close()

      })
    }

  },
};

</script>
<style lang="scss" scoped>
::v-deep .vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}

::v-deep .vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}

::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00c4b3 !important;
  border-color: #00c4b3 !important;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00c4b3;
  border-color: #00c4b3;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #00c4b3 !important;
}


.tab {
  margin-left: 20px;
}

.table_main {
  width: 28%;
}

.btn_zdy {
  margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .vxe-grid .vxe-button.type--button.is--circle {
  display: none;
}

::v-deep .vxe-grid .vxe-table {
  /* overflow: hidden; */
  border: 1px solid #ededed;
  margin-right: 10px;
}

.iname {
  margin-left: 35px;
  display: flex;
  align-items: center;
  flex-direction: row;

  span {
    font-weight: 400;
    text-align: right;
    // width: 112px;
    position: relative;
    font-size: 12px;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.iname2 {
  margin: 0px 15px;


  .item1 {
    line-height: 36px;

    span {
      font-weight: 400;
      text-align: right;
      width: 112px;
      position: relative;
      font-size: 12px;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);
    }
  }

}

.title1 {
  font-weight: 400;
  text-align: right;
  width: 81px;
  position: relative;
  font-size: 12px;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);

}

.brand {
  margin: 20px 0 0px 20px;
  display: flex;

  span {
    font-weight: 400;
    text-align: right;
    width: 112px;
    position: relative;
    font-size: 12px;
    padding: 0 10px 0 25px;
    color: rgba(86, 86, 86, 0.96);
  }

  .brand_item2 {
    margin-left: 20px;
  }

}

#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.expand-wrapper {
  padding: 10px;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {

  position: absolute !important;
  bottom: -35px !important;

}

#containt .detail-wrap .d-cont {
  overflow: auto !important;
}

#containt .detail-wrap .d-cont .d-item:last-child {
  margin-bottom: 0px;
}

::v-deep .el-range-editor--medium.el-input__inner {
  height: 30px;
}
</style>
